<template>
        <v-alert 
                width="100%"
                type="error"
                 dismissible
                 close-text="Close"
                 @input="onClose" >
                {{text}}
        </v-alert>
</template>

<script>
    export default {
        name: "Alert",
            props: ['text'],
        methods: {
            onClose() {
                this.$emit('dismissed');
            }
        }
    }
</script>

<style scoped>

</style>